/* Bubebaby — assets/bb.js = mock/bb.FROZEN.js + asserted port patches (port/port_assets.py). Vanilla, no deps. Reveal + draw-on motif + parallax + drawer + snap row + footer accordion. */
(function () {
  var d = document; d.documentElement.classList.add('js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // stroke-draw: measure each path once
  d.querySelectorAll('[data-bb-draw] path').forEach(function (p) {
    try { p.style.setProperty('--len', Math.ceil(p.getTotalLength() + 2)); } catch (e) {}
  });

  // reveal (plain descendant query; IO + top<0 + rAF sweep; once)
  var targets = Array.prototype.slice.call(d.querySelectorAll('[data-bb-reveal],[data-bb-draw]'));
  function show(el) { if (!el.classList.contains('is-in')) el.classList.add('is-in'); }
  if (reduce) { targets.forEach(show); }
  else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting || en.boundingClientRect.top < 0) { show(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
    targets.forEach(function (t) { io.observe(t); });
    var ticking = false;
    function sweep() {
      ticking = false; var h = window.innerHeight;
      targets.forEach(function (t) { if (t.classList.contains('is-in')) return; var r = t.getBoundingClientRect(); if (r.top < h * 0.9 || r.bottom < 0) show(t); });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(sweep); } }, { passive: true });
    window.addEventListener('load', sweep);
  }

  // parallax on the large motif shapes only (strength 0.08–0.12, transform only)
  var px = Array.prototype.slice.call(d.querySelectorAll('[data-bb-parallax]'));
  if (px.length && !reduce) {
    var pt = false;
    function para() {
      pt = false; var h = window.innerHeight;
      px.forEach(function (el) {
        var r = el.getBoundingClientRect(); var c = (r.top + r.height / 2) - h / 2; var s = parseFloat(el.getAttribute('data-bb-parallax')) || 0.1;
        el.style.transform = 'translate3d(0,' + (-c * s).toFixed(1) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () { if (!pt) { pt = true; requestAnimationFrame(para); } }, { passive: true });
    para();
  }

  // pointer parallax in the hero: the big shapes lean toward the cursor (desktop, fine pointer only)
  var hero = d.querySelector('.bb-hero');
  if (hero && !reduce && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    var shapes = hero.querySelectorAll('[data-bb-pointer]'); var raf = false, mx = 0, my = 0;
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect(); mx = (e.clientX - r.left) / r.width - .5; my = (e.clientY - r.top) / r.height - .5;
      if (!raf) { raf = true; requestAnimationFrame(function () { raf = false; shapes.forEach(function (s) { var k = parseFloat(s.getAttribute('data-bb-pointer')) || 20; s.style.transform = 'translate(' + (mx * k).toFixed(1) + 'px,' + (my * k).toFixed(1) + 'px)'; }); }); }
    }, { passive: true });
    hero.addEventListener('mouseleave', function () { shapes.forEach(function (s) { s.style.transform = ''; }); });
  }

  // drawer
  var drawer = d.querySelector('.bb-drawer');
  if (drawer) d.querySelectorAll('[data-bb-drawer]').forEach(function (b) {
    b.addEventListener('click', function () {
      var open = b.getAttribute('data-bb-drawer') === 'open';
      drawer.classList.toggle('is-open', open); d.body.style.overflow = open ? 'hidden' : '';
    });
  });

  // snap rows (testimonials on phones): arrows + n / N counter
  d.querySelectorAll('[data-bb-row]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-bb-track]'); var items = track.children; var out = wrap.querySelector('output');
    var prev = wrap.querySelector('[data-bb-prev]'); var next = wrap.querySelector('[data-bb-next]');
    function idx() { var x = track.scrollLeft + 1; var i = 0; for (var k = 0; k < items.length; k++) { if (items[k].offsetLeft - track.offsetLeft <= x) i = k; } return i; }
    function upd() { if (out) out.value = (idx() + 1) + ' / ' + items.length; }
    function go(n) { var i = Math.max(0, Math.min(items.length - 1, idx() + n)); track.scrollTo({ left: items[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true }); upd();
  });

  // best-seller tabs (filter cards by data-tag, no layout jump: hidden cards drop out of the grid)
  d.querySelectorAll('[data-bb-tabs]').forEach(function (tabs) {
    var grid = tabs.closest('section').querySelector('[data-bb-tabgrid]');
    tabs.querySelectorAll('[data-bb-tab]').forEach(function (t) {
      t.addEventListener('click', function () {
        var k = t.getAttribute('data-bb-tab');
        tabs.querySelectorAll('[data-bb-tab]').forEach(function (o) { o.classList.toggle('is-on', o === t); o.setAttribute('aria-selected', o === t ? 'true' : 'false'); });
        grid.querySelectorAll('.bb-card').forEach(function (c, i) { var on = k === 'all' || c.getAttribute('data-tag') === k; c.classList.toggle('is-off', !on); if (on) { c.classList.remove('is-in'); c.style.setProperty('--i', i % 4); requestAnimationFrame(function () { c.classList.add('is-in'); }); } });
      });
    });
  });

  // scene pins: first one open; tap toggles on touch
  d.querySelectorAll('[data-bb-pins]').forEach(function (st) {
    var pins = st.querySelectorAll('.bb-pin'); if (pins[0]) pins[0].classList.add('is-open');
    pins.forEach(function (p) { p.addEventListener('click', function (e) { if (window.matchMedia('(hover:none)').matches) { e.preventDefault(); pins.forEach(function (o) { o.classList.toggle('is-open', o === p && !p.classList.contains('is-open')); }); } }); });
  });

  // like hearts + cart bump

  // footer accordions on phones
  d.querySelectorAll('.bb-footer__col b').forEach(function (h) {
    h.addEventListener('click', function () { if (window.innerWidth > 767) return; h.parentNode.classList.toggle('is-open'); });
  });

  // header shadow after scroll
  var hd = d.querySelector('.bb-header');
  if (hd) window.addEventListener('scroll', function () { hd.classList.toggle('is-scrolled', window.scrollY > 8); }, { passive: true });

})();
